<template>
	<!-- 总平台管理－生成预约库存-->
	<content-view>
		<div class="createInventory">
		<a-alert style="margin-bottom:20px" description="库存设置成功立即生效，请慎重操作！" type="warning" showIcon/>
		<div id="components-layout-demo-basic">
			<a-layout>
				<a-layout-sider style="border:1px solid rgba(233, 233, 233, 1)">
					<inventory-list @createInit="createInit"></inventory-list>
				</a-layout-sider>
				<a-layout style="background:#fff">
					<div class="district">
						<a-form :form="form" class="ticket-one-form">
							<a-form-item label="日期范围：" class="text-left" :labelCol="{span: 6}" :wrapperCol="{span:16}">
							<a-range-picker :disabledDate="disabledDate" @change="rangeChange" style="width:80%;" v-decorator="['dataRange',{initialValue:[moment(lastDate)], rules:[{required:true,message:'请选择时间!'}]}]"/>
							</a-form-item>
							<a-form-item label="选择排除星期" :labelCol="{span: 6}" :wrapperCol="{span:18}" style="text-align:left;">
								<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
								<a-checkbox-group :options="weekOption" @change="onWeekChange" v-model="weekSelected"></a-checkbox-group>
							</a-form-item>
							<a-form-item style="margin-left:17%" label :labelCol="{span: 4}" :wrapperCol="{span:8}">
								<a @click="add" style="margin:0;">增加排除日期</a>
							</a-form-item>
							<a-form-item
							v-for="(k, index) in form.getFieldValue('keys')"
							:key="'excludeDates' + (k+1)"
							label="排除日期范围："
							:index="index"
							:required="false"
							:labelCol="{span: 6}"
							:wrapperCol="{span: 16}"
							class="text-left"
							>
								<a-range-picker :disabledDate="disabledExcludeDate" style="width:80%;" v-decorator="[`excludeDates[${k}]`,]" />
								<div class="float-right pr64">
									<span class="point text-primary" @click="() => remove(k)">删除</span>
								</div>
							</a-form-item>

							<div class="bom"></div>
							<!-- 添加场次模板 -->
							<template v-for="(key, index) in form.getFieldValue('periodListkeys')">
								<div :key="'addPeriodInfoDTOS' + key">
									<a-form-item class="text-right" v-if="index==0">
										<a-row>
											<a-col :span="6">
												<span class="point text-primary" @click="visible = true">新增场次类型</span>
											</a-col>
										</a-row>
									</a-form-item>
									<a-form-item label="场次类型：" :labelCol="{span: 6}" :wrapperCol="{span: 18}" class="text-left">
										<a-select v-decorator="[`typeList[${key}]`, {rules:[{required: true, message: '请选择'}]}]" placeholder="请选择场次类型" style="width: 30%" class="mr16" @change="storeTypeChange">
											<a-select-option v-for="item in storeTypes" :value="JSON.stringify(item)" :key="item.id" :keys="key">{{item.name}}</a-select-option>
										</a-select>
										<a-input style="width:20%" placeholder="请先选择场次类型" disabled v-decorator="[`periodStarTimetList[${key}]`]" />
										至
										<a-input style="width:20%" placeholder="请先选择场次类型" disabled v-decorator="[`periodEndTimeList[${key}]`]" />
										<span class="point text-primary ml16" @click="periodAdd" v-if="index==form.getFieldValue('periodListkeys').length-1">新增场次库存</span>
										<span class="point text-primary ml16" v-if="index<form.getFieldValue('periodListkeys').length-1" @click="periodRemove(key)">删除场次库存</span>
									</a-form-item>
									<a-form-item label="库存总量/份：" :labelCol="{span: 6}" :wrapperCol="{span: 18}" class="text-left">
										<a-input-number :precision="0" :min="1" v-decorator="[`stockList[${key}]`, {rules:[{required: true, message: '请输入'}]}]" style="width:30%;"/>
									</a-form-item>
								</div>
							</template>
							<a-row>
								<a-col :span="24" class="text-center">
									<a-button type="primary" :loading="loading" @click="handleSubmit">保存</a-button>
									<a-button @click="goBack">取消</a-button>
								</a-col>
							</a-row>
						</a-form>
					</div>
				</a-layout>
			</a-layout>
		</div>
		</div>
		<a-modal
		title="新增场次类型"
		:visible="visible"
		@ok="addStoreTypeSubmit"
		:confirmLoading="confirmLoading"
		@cancel="handleCancel"
		>
			<a-form :form="addPreiodTypeForm">
					<a-form-item style="line-height:50px" :label-col="{span:6}" :wrapper-col="{span:18}" label="场次名称：">
						<a-input placeholder="请输入" @input="onInputCheck" v-decorator="['name',formRules.name]"/>
						<div class="name-repeat-tips" v-if="isRepeat">场次类型名称已存在！</div>
					</a-form-item>
					<a-form-item style="line-height:50px" :label-col="{span:6}" :wrapper-col="{span:18}" label="场次开始时间：">
						<a-time-picker style="width:100%;" format="HH:mm" v-decorator="['time[0]',formRules.time]" placeholder="请选择"></a-time-picker>
					</a-form-item>
					<a-form-item style="line-height:50px" :label-col="{span:6}" :wrapper-col="{span:18}" label="场次结束时间：">
						<a-time-picker style="width:100%;" format="HH:mm" v-decorator="['time[1]',formRules.time]" placeholder="请选择"></a-time-picker>
					</a-form-item>
			</a-form>
		</a-modal>
	</content-view>
</template>

<script type="text/javascript">
let id = -1;
let pid =0;

import inventoryList from "@/components/modules/platform/Inventory.list.component";
import moment from "moment";
import { mapGetters } from "vuex";
var formRules ={
	dataRange:{rules:[{required:true,message:"请选择时间!"}]},
	name:{rules:[{required:true,message:"请填写名称！"}]},
	time:{rules:[{required:true,message:"请填写时间！"}]}
}
const weekOption=[
	{label:"周一",value:1},
	{label:"周二",value:2},
	{label:"周三",value:3},
	{label:"周四",value:4},
	{label:"周五",value:5},
	{label:"周六",value:6},
	{label:"周日",value:7},
	]
export default {
	name: "createInventory",
	components: { inventoryList },
	props: {},
	data() {
		return {
			/**
			 * @addPeriodInfoDTOS {array} 场次列表
			 * @excludeDates {array} 排除时间列表
			 */
			weekOption,
			weekSelected:[],
			indeterminate:false,
			checkAll:false,
			id: this.$route.query.id,
			visible: false,
			formRules,
			neweSsionType: "",
			confirmLoading: false,
			storeTypes: [],
			addPeriodInfoDTOS: [],
			excludeDates: [],
			showAddStoreType:false,
			isRepeat:false,
			lastDate:moment(),
			ExcludeDisabled:[moment(),moment()],
			loading: false,
		};
	},
	computed: {
		...mapGetters(["currentItem", "currnetId","shopId", "shopName"])
	},
	watch:{
	},
	methods: {
		/**
		 * @remove {method} 移除排除日期
		 */
		remove(k) {
			const { form } = this;
			const keys = form.getFieldValue("keys");
			form.setFieldsValue({
				keys: keys.filter(key => key !== k)
			});
		},
		/**
		 * @add {method} 增加排除日期
		*/
		add() {
			const { form } = this;
			const keys = form.getFieldValue("keys");
			const nextKeys = keys.concat(++id);
			form.setFieldsValue({
				keys: nextKeys
			});
		},
		/**
		 * @periodAdd {method} 增加场次库存
		*/
		periodAdd () {
			let { form } = this;
			let keys = form.getFieldValue("periodListkeys");
			let nextKeys = keys.concat(++pid);
			form.setFieldsValue({
				periodListkeys: nextKeys
			});
		},
		/**
		 * @periodRemove {method} 删除场次库存
		*/
		periodRemove(k) {
			let { form } = this;
			let keys = form.getFieldValue("periodListkeys");
			form.setFieldsValue({
				periodListkeys: keys.filter(key => key !== k)
			});
		},
		moment,
		/**
		 *@storeTypeChange 场次类型选择
		*/
		storeTypeChange (value,vNode) {
			var val = JSON.parse(value);
			var keys= vNode.data.attrs.keys;
			this.form.setFieldsValue({[`periodStarTimetList[${keys}]`]: val.startTime});
			this.form.setFieldsValue({[`periodEndTimeList[${keys}]`]: val.endTime});
		},
		/**
		 *@addStoreTypeSubmit {method} 弹窗确认添加场次类型
		*/ 
		addStoreTypeSubmit () {
			if( this.isRepeat ){
				return false;
			}
			this.addPreiodTypeForm.validateFields((err,values) =>{
				if(!err){
					this.confirmLoading = true;
					// 添加场次类型
					this.$api.totalPlatform.addStoreType({
						body: {
							name: values.name,
							shopId: this.shopId,
							shopName: this.shopName,
							startTime: moment(values.time[0]._d).format("HH:mm") + ":00",
							endTime: moment(values.time[1]._d).format("HH:mm") + ":00"
						}
					}).then((res) => {
						this.getStoreTypes();
						this.confirmLoading=false;
						this.visible=false;
						this.$message.success("添加成功！");
					}).catch(err => {
						this.$message.success("添加失败！");
					})
				}
			})
		},
		/**
		 * @getStoreTypes {method} 获取所有场次类型
		 */
		getStoreTypes () {
			this.addPreiodTypeForm.validateFields((err,values) =>{
				if (err) return;
				this.$api.totalPlatform.storeTypes({
					params:{
						shopId: this.shopId
					}
				}).then((data) => {
					this.storeTypes = data;
				})
			})
		},
		/**
		 * @handleSubmit {method} 提交场次库存监听回调
		 */
		handleSubmit() {
			this.form.validateFields((err, values) => {
				if (!err) {
					if (values.dataRange.length < 2) {
						this.$message.warn("请填写时间");
						return
					}
					let excludeDates = [],
						addPeriodInfoDTOS = [];
					// 排除日期
					if(values.excludeDates){
						values.excludeDates.forEach(item => {
							let rangeTimes = item[1] - item[0];
							let rangeDayCount = (rangeTimes / 86400000);
							for( let i = 0; i <= rangeDayCount; i++ ) {
								excludeDates.push(moment(item[0]._d).add(i, 'days').format("YYYY-MM-DD"));
							}
						});
					}
					// 场次列表
					values.periodStarTimetList.forEach((item,key) => {
						addPeriodInfoDTOS.push({
							endTime: values.periodEndTimeList[key],
							periodTypeId: JSON.parse(values.typeList[key]).id,
							reserveStockPeriodType: JSON.parse(values.typeList[key]).name,
							startTime: item,
							capacity: values.stockList[key]
						});
					});
					this.loading = true;
					this.$api.totalPlatform.batchAddPeriod({
						body: {
							reserveStockId: this.currnetId,
							endDate: values.dataRange[1].format("YYYY-MM-DD"),
							startDate: values.dataRange[0].format("YYYY-MM-DD"),
							addPeriodInfoDTOS: addPeriodInfoDTOS,
							excludeDates: excludeDates,
							excludeWeeks: this.weekSelected,
							operator: this.uesrInfo.name,
							operatorId: this.uesrInfo.id,
							operatorType: 2
						}
					}).then(res => {
						this.loading = false;
						this.$message.success("添加成功！");
						this.goBack();
					}).catch(err => {
						this.loading = false;
					})
				}
			});
		},
		/**
		 *@onWeekChange {method} 是否全选状态判断
			*/
		onWeekChange (checkedList) {
			this.indeterminate = !!checkedList.length && (checkedList.length < weekOption.length)
			this.checkAll = checkedList.length === weekOption.length
		},
		/**
		 *@onCheckAllChange {method} 是否全选操作
			*/
		onCheckAllChange (e) {
			let weedVal=[];
			weekOption.forEach((item,index) =>{
				weedVal.push(item.value);
			})
			Object.assign(this, {
				weekSelected: e.target.checked ? weedVal : [],
				indeterminate: false,
				checkAll: e.target.checked,
			})
		},
		goBack() {
			this.$router.go(-1);
		},
		handleCancel(e) {
			this.visible = false;
		},
		/**
		 * 检查库存类型是否已经存在
		 */
		onInputCheck (e) {
			let val = e.target.value;
			this.isRepeat = this.storeTypes.find((item) => val === item.name) ? true : false;
		},
		/**
		 *@disabledDate {method} 返回某天是否禁用
		*/
		disabledDate (momentDate) {
			if(momentDate.valueOf()<this.lastDate.valueOf()){
				return true;
			}
		},
		/**
		 *@disabledDate {method} 范围禁用
		*/
		disabledExcludeDate (momentDate) {
			if(momentDate.valueOf()-84600000<=this.ExcludeDisabled[0].valueOf()||momentDate.valueOf()>=this.ExcludeDisabled[1].valueOf()){
				return true;
			}
		},
		/**
		 *@rangeChange {method} 范围选择改变事件
		*/
		rangeChange (value) {
			this.ExcludeDisabled=value;
		},
		/**
		 *@createInit {method} 页面初始化
		*/
		createInit () {
			setTimeout(() => {
				this.getStoreTypes();
			},500)
		}
	},
	beforeCreate() {
		this.form = this.$form.createForm(this);
		this.addPreiodTypeForm = this.$form.createForm(this);
		this.form.getFieldDecorator("keys", { initialValue: [], preserve: true });
		this.form.getFieldDecorator("periodListkeys", { initialValue: [0], preserve: true });
		this.form.getFieldDecorator("typeList[0]");
		this.form.getFieldDecorator("periodStarTimetList[0]");
		this.form.getFieldDecorator("periodEndTimeList[0]");
		this.form.getFieldDecorator("stockList[0]");
		this.uesrInfo = this.$userInfoTool.getUser();
	},
	created() {},
	mounted() {
			
	}
};
</script>
<style lang="scss">
.createInventory {
  background-color: #fff;
  padding: 24px 32px;
  border-radius: 2px;
  min-height: 650px;
}
.district {
  width: 98%;
  height: 100%;
  margin-left: 2%;
  border: 1px solid rgba(233, 233, 233, 1);
  padding: 24px 0;
  border-radius: 2px;
  a {
    margin-left: 20px;
    color: $text-color-primary;
    text-decoration: underline;
    float: left;
  }
  .bom {
    width: 100%;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid rgba(233, 233, 233, 1);
  }
}
#components-layout-demo-basic {
  text-align: center;
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  background: #7dbcea;
  color: #fff;
}
#components-layout-demo-basic .ant-layout-footer {
  line-height: 1.5;
}
#components-layout-demo-basic .ant-layout-sider {
  background: #fff;
  color: #000000;
  font-size: 16px;
  .title {
    line-height: 60px;
    border: 1px solid rgba(233, 233, 233, 1);
    a {
      color: $text-color-primary;
    }
  }
}
.name-repeat-tips{
  color:#F5222D;
  position: absolute;
  top:20px;
  left:0;
  width: 150px;
}
</style>